import { Route } from '@angular/router';
import { ScreensViewComponent } from './screens-view.component';


export const screensViewRoute: Route = {
    path: 'edit/caseId/:caseId/lifeInstance/:lifeInstance/interviewCode/:interviewCode',
    component: ScreensViewComponent,
    data: {
        authorities: [],
        pageTitle: 'activate.title'
    }
};
